import { render, staticRenderFns } from "./ClassicTimesheetView.vue?vue&type=template&id=671e6572"
import script from "./ClassicTimesheetView.vue?vue&type=script&lang=js"
export * from "./ClassicTimesheetView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports